import React from 'react';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { md } from 'src/utils/media-queries';
import { LandscapeFooter } from './landscape-footer';
import { PortraitFooter } from './portrait-footer';

const Footer: React.FC = () => {
  const isMdOrAbove = useMediaQuery(`(${md}`);

  return isMdOrAbove ? <LandscapeFooter /> : <PortraitFooter />;
};

export { Footer };
